import { render } from "./declareDetails.vue?vue&type=template&id=0a590cd3&scoped=true"
import script from "./declareDetails.vue?vue&type=script&lang=js"
export * from "./declareDetails.vue?vue&type=script&lang=js"

import "./declareDetails.vue?vue&type=style&index=0&id=0a590cd3&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a590cd3"]])

export default __exports__